import { SocketEvent } from '@debbie/common/dist/web-sockets';
import { h } from '..';
import * as importsLib from '../api/imports';
import { fetchLoadable } from '../fetchLoadable';
import { dispatch } from '../internal';
import { subscribeToEvent } from '../socket';
import store from '../store';
import * as actionTypes from './actionTypes';
export const getAllPaged = (quantity, from, reset) => {
    const state = store.getState();
    const imports = state.allImports;
    return fetchLoadable(actionTypes.FETCH_IMPORTS, importsLib.getAllImports, {
        from: typeof from === 'number'
            ? from
            : h.hasData(imports)
                ? imports.data.from
                : 0,
        quantity,
        reset,
    }, true);
};
export const get = (importId) => {
    return fetchLoadable(actionTypes.FETCH_IMPORT, importsLib.get, {
        importId,
    });
};
export const getAll = () => {
    return fetchLoadable(actionTypes.FETCH_ALL_IMPORTS, importsLib.getAllImports, {
        from: 0,
    });
};
export const deleteImport = (importId) => {
    dispatch({ type: actionTypes.DELETE_IMPORT, payload: { importId: importId } });
};
export const getAmountAppendices = (importId) => fetchLoadable(actionTypes.FETCH_AMOUNT_APPENDICES, importsLib.getAmountAppendices, { importId });
const importStatusUpdate = (importId, status) => {
    if (status &&
        status.cases &&
        status.cases.run &&
        status.cases.total === status.cases.run) {
        getAllPaged(40, 0, true);
        // Loading before transaction is committed
        setTimeout(() => get(importId), 3000);
    }
    dispatch({
        type: actionTypes.SET_STATUS_UPDATE,
        payload: { importId, status },
    });
};
export const getFailedRows = (importId) => fetchLoadable(actionTypes.FETCH_FAILED_ROWS_FILE, importsLib.getFailedRows, {
    importId,
});
subscribeToEvent(SocketEvent.IMPORTSTATUS, importStatusUpdate);
//# sourceMappingURL=actions.js.map